import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import {Observable, Subscription} from 'rxjs';
import {Rules, RulesForm} from '../../../contract/models/rules';
import {Contract} from '../../../contract/models/contract';
import {FormGroup} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ActionsSubject, select, Store} from '@ngrx/store';
import * as fromContracts from '../../../contract/reducers';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {CompanyService} from '../../../company/services/company.service';
import {RulesMapperService} from '../../../contract/services/rules-mapper.service';
import {ContractMapperService} from '../../../contract/services/contract-mapper.service';
import {DuplicateService} from '../../services/duplicate.service';
import {UpdateDynamicFormService} from '../../services/update-dynamic-form.service';
import * as fromShared from '../../reducers';
import {LoadMyCompaniesLinkContractAction} from '../../actions/companies-link-contract';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import * as _ from 'lodash';
import {DuplicateContract} from '../../models/contract-link';
import {LoadRulesContractIDAction, RulesClearAction} from '../../../contract/actions/contract-rules-load';
import {DuplicationContractAction, DuplicationContractSuccessAction} from '../../actions/contract-duplication';
import {DuplicationRuleAction} from '../../actions/rule-duplication';
import {LoadContractAction} from '../../../contract/actions/contract-load';
import * as moment from 'moment';
import {SelectedItem} from '../../../order/models/order';
import * as fromRoot from '../../reducers';
import {ProjectEditAction, ProjectEditWithOutAction} from '../../actions/project-creation';
import {ReturnPlayerUpdateStatusAction} from '../../actions/anomaly-player-return';

@Component({
  selector: 'storever-modal-edit-sf-project',
  templateUrl: './modal-edit-sf-project.component.html',
  styleUrls: ['./modal-edit-sf-project.component.css']
})
export class ModalEditSfProjectComponent implements OnInit, OnDestroy {
  @ViewChild('staticModal' , {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  // tslint:disable-next-line:no-any
  selectedOneItem$: Observable<any>;
  myForm: FormGroup;
  formConfig: GroupConfig;
  error = 'false';
  errorName = 'false';
  name: string;
  uuid: string;
  clientProjectID: string;

  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private activatedRoute: ActivatedRoute,
              private store: Store<fromShared.AppState>,
              private dispatcher: ActionsSubject,
              private router: Router,
              private storeRoot: Store<fromRoot.AppState>,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private bsModalRef: BsModalRef) {

  }

  ngOnInit(): void {
    this.myForm = this.getFormsService.getProjectCreation();
    this.formConfig = this.getConfigSharedService.getConfigSFProject();
    this.selectedOneItem$ = this.storeRoot.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    this.selectedOneItem$.subscribe(data => {
      if (data) {
        this.name = data.name;
        this.uuid = data.uuid;
        this.clientProjectID = data.clientProjectID;
      }
    })

  }


  // tslint:disable-next-line:no-any
  send(value: any): void {
    if (this.router.url.split('?')[0].split('/')[1] !== 'anomalies') {
      this.store.dispatch(new ProjectEditAction({
          'salesforceProjectId': value.salesforceProjectId,
          'clientProjectID': this.clientProjectID,
          'name': value.name,
          'client': {
            'uuid': this.uuid
          }
        }
      ));
    } else {
      this.store.dispatch(new ProjectEditWithOutAction({
          'salesforceProjectId': value.salesforceProjectId,
          'clientProjectID': this.clientProjectID,
          'name': value.name,
          'client': {
            'uuid': this.uuid
          }
        }
      ));
    }

    this.close();
  }

  open(): void {
    this.staticModal.show();
  }

  close(): void {
    if (this.staticModal) {
      this.staticModal.hide();
    } else {
      this.bsModalRef.hide();
    }
  }

  disabled(): boolean {
    return !((this.myForm.value.name && !this.myForm.value.salesforceProjectId) || (!this.myForm.value.name && this.myForm.value.salesforceProjectId))
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }
}


